import React from "react";
import "./About.css"

const About = () => {
    return (
        <div className="slider-content-container">
            <div className="centered">
                <div className="two-column about-text">
                    <h1>👋 Hey, I'm Juan J. Gomez</h1>
                    <p>🌐 I turn ideas into seamless web applications using HTML, CSS, JavaScript, React, Node, and more. My goal? Dazzling user experiences that leave a mark.</p>
                    <p>🔍 Tech is my playground. From iOS to web development, I'm always learning. Currently diving deep into Data Science Courses by Harvard University.</p>
                    <p>🌟 At Eversana Intouch, I'm an intern crafting web apps with HTML, CSS, React, and more. As a tech lead at the Google Developer Student Club, I ignite minds and foster innovation.</p>
                    <p>🤖 Whether it's AI-infused Pacman games or facial recognition wizardry, I love making machines do magic.</p>
                    <p>🎓 I'm a Computer Science Graduate enthusiast at USF with a 3.4 GPA. Courses like operating systems, AI/ML, and more keep me curious.</p>
                    <p>🌴 When not coding, you'll find me soaking up Tampa's sun. Let's connect and make tech magic! 🌐🤝</p>
                </div>
            </div>
        </div>
    );
}

export default About